// src/components/Hero.js
import React from "react";
import { Link } from "react-router-dom";
import { Search, ArrowRight } from 'lucide-react';

const Hero = () => {
  return (
    <section className="bg-transparent py-12 pt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="animate-fadeInUp">
            <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              Master U.S. Real Estate Data
            </h1>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              Unlock the power to purchase comprehensive real estate datasets across the USA for your business or investment needs.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Link to="/signup" className="bg-blue-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-blue-700 hover:scale-105 transition-transform flex items-center justify-center group">
                Buy Data Now
                <ArrowRight className="w-5 h-5 ml-2 transition-transform group-hover:translate-x-2" />
              </Link>
              <Link to="#how-it-works" className="bg-gray-200 text-gray-700 px-8 py-4 rounded-lg font-semibold hover:bg-gray-300 hover:scale-105 transition-transform flex items-center justify-center group" onClick={(e) => {
                e.preventDefault();
                document.querySelector('#how-it-works').scrollIntoView({ behavior: 'smooth' });
              }}>
                <Search className="w-5 h-5 mr-2" />
                Learn How
                <ArrowRight className="w-5 h-5 ml-2 transition-transform group-hover:translate-x-2" />
              </Link>
            </div>
          </div>
          <div className="relative animate-fadeIn">
            <div className="bg-white rounded-2xl p-8" style={{ boxShadow: '0 8px 12px 4px rgba(147, 197, 253, 0.3)' }}>
              <div className="aspect-video bg-gray-200 rounded-lg flex items-center justify-center mb-4">
                <Search className="w-16 h-16 text-gray-400" />
              </div>
              <div className="space-y-3">
                <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                <div className="h-4 bg-gray-200 rounded w-1/2"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;